import { type MetaFunction } from '@remix-run/node'

import { Footer, Header } from '#app/components'
import { Wrapper } from '#app/components/ui'
import { useOptionalUser } from '#app/utils/user.ts'

export default function TermsOfServiceRoute() {
	const user = useOptionalUser()
	const isLoggedIn = user?.id ? true : false
	return (
		<main>
			<Header isLoggedIn={isLoggedIn} />
			<div className="flex w-full flex-col items-center">
				<Wrapper>
					<div className="bg-white px-6 py-24 dark:bg-background sm:py-32 lg:px-8">
						<div className="mx-auto max-w-2xl text-left">
							<h2 className="mt-2 text-center text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-6xl">
								Terms of Service
							</h2>
							<p className="my-6 py-4 text-center text-lg leading-8 text-gray-600 dark:text-gray-300">
								Welcome to Top Timelines! Below are our Terms of Service, which
								outline the rules and regulations for the use of the Top
								Timelines Website, located at https://toptimelines.com.
							</p>
							<h3 className="text-lg font-semibold">1. Agreement to Terms</h3>
							<p className="py-4 leading-8">
								By accessing our site and using our services, you agree to be
								bound by these Terms. If you disagree with any part of the
								terms, you do not have permission to access our services.
							</p>
							<h3 className="text-lg font-semibold">
								2. Intellectual Property
							</h3>
							<p className="py-4 leading-8">
								The content, organization, graphics, design, and other matters
								related to our site are protected under applicable copyrights
								and trade laws. The copying, redistribution, use or publication
								of any such matters or any part of the site is strictly
								prohibited without express written permission.
							</p>
							<h3 className="text-lg font-semibold">3. Your Account</h3>
							<p className="py-4 leading-8">
								If you use our site, you are responsible for maintaining the
								confidentiality of your account and password and for restricting
								access to your computer, and you agree to accept responsibility
								for all activities that occur under your account or password.
							</p>
							<h3 className="text-lg font-semibold">4. Termination</h3>
							<p className="py-4 leading-8">
								We may terminate or suspend access to our Service immediately,
								without prior notice or liability, for any reason whatsoever,
								including without limitation if you breach the Terms.
							</p>
							<h3 className="text-lg font-semibold">5. Governing Law</h3>
							<p className="py-4 leading-8">
								These Terms shall be governed and construed in accordance with
								the laws of the United States, without regard to its conflict of
								law provisions.
							</p>
							<p className="mt-6">
								If you have any questions or suggestions about our Terms of
								Service, do not hesitate to contact us at
								hello@toptimelines.com.
							</p>
						</div>
					</div>
				</Wrapper>
			</div>
			<Footer />
		</main>
	)
}

export const meta: MetaFunction = () => [{ title: 'Top Timelines | Terms' }]
